import * as React from 'react';

import type {GetLead_lead_stages_edges as StageEdge} from 'nutshell-graphql-types';

import {Popover} from '../../popover/popover';
import {StageStatusHoverview} from '../../stage-status-hoverview/stage-status-hoverview';

type Props = {
    stage: StageEdge;
    popoverAnchorRef: HTMLButtonElement;
    isPopoverStageActive: boolean;
    onPopoverHoverChange?: (isHovered: boolean) => void;
    pipelineId: string;
    canAccessSetup: boolean;
};

// A custom component similar to our HoverPopover. Due to how it handles
// internal state, we could not use the HoverPopover component. In this case, we
// need that state to be managed by the stage carousel to handle multi-stage
// interactions + timeouts.
export function StagePopover(props: Props) {
    const {onPopoverHoverChange} = props;
    const popoverContentRef = React.useRef<HTMLDivElement | null | undefined>(null);

    React.useEffect(() => {
        const popoverElement = popoverContentRef.current;
        if (!popoverElement || !onPopoverHoverChange) {
            return;
        }

        const handleMouseEnter = () => {
            onPopoverHoverChange(true);
        };

        const handleMouseLeave = () => {
            onPopoverHoverChange(false);
        };

        popoverElement.addEventListener('mouseenter', handleMouseEnter);
        popoverElement.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            popoverElement.removeEventListener('mouseenter', handleMouseEnter);
            popoverElement.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [onPopoverHoverChange]);

    return (
        <Popover shouldFadeIn={true} anchor={props.popoverAnchorRef} location='bottom'>
            {/* @ts-expect-error */}
            <div ref={popoverContentRef}>
                <StageStatusHoverview
                    name={props.stage.node.name}
                    timeInStage={props.stage.timeInStage && props.stage.timeInStage.formattedString}
                    guidance={props.stage.node.description}
                    goals={props.stage.goalConditions.map(
                        (goal) => goal.condition.humanReadableObjectiveString
                    )}
                    isActive={props.isPopoverStageActive}
                    pipelineId={props.pipelineId}
                    canAccessSetup={props.canAccessSetup}
                />
            </div>
        </Popover>
    );
}
